module.exports = __webpack_public_path__ + "static/media/score_heatmap_5.ce369342.png";